/**********************************************************************
 * WARNING: This file was autogenerated by util-protos generateFiles.js
 * Do not manually edit!
 ***********************************************************************/

import { post, CashRequestOptions } from '@cash-web/shared-util-fetch'
import {BatchGetUnitRequest} from '@cash-web/protos/squareup/roster/mds.pb'
import {BatchGetUnitResponse} from '@cash-web/protos/squareup/roster/mds.pb'


export const batchGetUnit = (request: BatchGetUnitRequest, options?: CashRequestOptions) => post<BatchGetUnitRequest, BatchGetUnitResponse>("/2.0/cash/batch-get-unit", request, {...options, rejectOnError: true })